import type { VoidFunctionComponent } from 'react';

import { REPORTS_V2 } from '../../../../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../../../../helpers/features';
import Toggle from '../../../../../../generic/Toggle';
import useReportContainer from '../../../context/useReportContainer';

import styles from './RegulatoryComplianceToggles.module.less';

/**
 * Component for toggling between Reports V1 and V2 when the REPORTS_V2 feature flag is enabled
 */
const ReportsV2Toggle: VoidFunctionComponent = () => {
  const isReportsV2Enabled = useIsFeatureEnabled(REPORTS_V2);
  const { useReportsV2Toggle, setUseReportsV2Toggle } = useReportContainer();

  // Only show the toggle if the feature flag is enabled
  if (!isReportsV2Enabled) {
    return null;
  }

  return (
    <div className={styles.regulatoryComplianceToggles}>
      <div className={styles.label}>Report Version</div>
      <div className={styles.toggle}>
        <Toggle
          checked={useReportsV2Toggle}
          onChange={(isChecked) => {
            setUseReportsV2Toggle(isChecked);
          }}
        />
        <div className={styles.label}>Use Reports V2</div>
      </div>
      <div className={styles.description}>
        Toggle between the new Reports V2 generation logic (recommended) and the legacy V1 implementation.
      </div>
    </div>
  );
};

export default ReportsV2Toggle;
